import { Button, IconButton } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faTimes } from "@fortawesome/free-solid-svg-icons";

const stop = (event, onClick) => {
  event.stopPropagation();
  onClick?.(event);
};

/** Grid overlay — opens gallery (no toggle handler). */
export function GalleryOpenButton({ label }) {
  return (
    <Button
      className="fursatook-gallery-open-btn"
      colorScheme="blackAlpha"
      bottom="10px"
      right="10px"
      position="absolute"
      variant="solid"
      leftIcon={<FontAwesomeIcon icon={faImage} />}
      color="white"
      pointerEvents="none"
      aria-hidden="true"
    >
      {label}
    </Button>
  );
}

/** Embedded + fullscreen controls for react-image-gallery. */
export function GalleryFullscreenButton({ label, onClick, isFullscreen = false }) {
  if (isFullscreen) {
    return (
      <>
        <IconButton
          className="fursatook-gallery-close-btn"
          icon={<FontAwesomeIcon icon={faTimes} />}
          onClick={(e) => stop(e, onClick)}
          aria-label="Close gallery"
          title="Close"
          position="fixed"
          top={{ base: "10px", md: "16px" }}
          right={{ base: "10px", md: "16px" }}
          zIndex={1401}
          size="lg"
          borderRadius="full"
          bg="blackAlpha.700"
          color="white"
          _hover={{ bg: "blackAlpha.900" }}
        />
        <Button
          className="fursatook-gallery-close-btn"
          onClick={(e) => stop(e, onClick)}
          colorScheme="blackAlpha"
          bottom="10px"
          right="10px"
          position="fixed"
          variant="solid"
          leftIcon={<FontAwesomeIcon icon={faImage} />}
          color="white"
          zIndex={1401}
          aria-label="Close gallery"
          title="Close"
        >
          {label}
        </Button>
      </>
    );
  }

  return (
    <Button
      className="fursatook-gallery-open-btn"
      onClick={(e) => stop(e, onClick)}
      colorScheme="blackAlpha"
      bottom="10px"
      right="10px"
      position="absolute"
      variant="solid"
      leftIcon={<FontAwesomeIcon icon={faImage} />}
      color="white"
      zIndex={5}
      aria-label="Open gallery"
      title="Open gallery"
    >
      {label}
    </Button>
  );
}

/** @deprecated Use GalleryFullscreenButton */
export const FullScreenButton = GalleryFullscreenButton;
